import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_All_From_MongoDB(dbName, collctiontext, setdata, logout) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Get_All_From_MongoDB",
        {
          dbName: dbName,
          collctiontext: collctiontext,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      console.log("Response Data: ", response);

      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      //Check if nothing found
      if (response.data.data.length === 0) {
        window.alert(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
      }
      //handle data set
      setdata(response.data.data); // Update your state with the fetched data
      //Catch Errors
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  //Run
  fetchData();
}
